import React, { useState, useContext, useEffect, useRef, useMemo, useCallback } from "react";
import GeneralContext from "../GeneralContext/GeneralContext";
import axios from "../../api/axios";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid2";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";

import TextField from "@mui/material/TextField";
import Chip from "@mui/material/Chip";
import Alert from "@mui/material/Alert";
import Autocomplete from "@mui/material/Autocomplete";
import FormControl from "@mui/material/FormControl";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import dayjs from "dayjs";
import "dayjs/locale/es";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Divider from "@mui/material/Divider";

import PageBody from "../GeneralComponents/PageBody";
import PageButtonBlack from "../GeneralComponents/PageButtonBlack";
import PageBgBlock from "../GeneralComponents/PageBgBlock";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";

import ModalStandard from "../GeneralComponents/ModalStandard";
import InputFake from "../GeneralComponents/InputFake";
import { useNavigate } from "react-router-dom";
import InputRut from "../GeneralComponents/InputRut";
import InputFile from "../GeneralComponents/InputFile";
import Checkbox from "@mui/material/Checkbox";

import ContingenciasHiddenPreview from "./ContingenciasHiddenPreview";
import HourglassLoader from "../GeneralComponents/HourglassLoader";
import PeriodosGraciaAlert from "../GeneralComponents/PeriodosGraciaAlert";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import OutlinedInput from "@mui/material/OutlinedInput";
import ListItemText from "@mui/material/ListItemText";
import { DAYS, DEFAULT_ITEMS_CONTINGENCIAS } from "../../Constants/Constants";

import {
  getValueByKey,
  parseBoldText,
  toSnakeCase,
} from "../utils/general_utils";

import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import TuneIcon from "@mui/icons-material/Tune";
import PageButtonSimple from "../GeneralComponents/PageButtonSimple";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
} from "@mui/material";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import ContingenciasSelection from "./ContingenciasSelection";

let g_start_date = new Date();
g_start_date.setDate(g_start_date.getDate() - 7);


export default function Contingencias() {
  const { userSesion, setPageTitle, setDrawerHidding } =
    useContext(GeneralContext);

  const [typeId, setTypeId] = useState(null);
  const [typeContingencia, setTypeContingencia] = useState("");
  const [subtypeContingencia, setSubtypeContingencia] = useState("");
  const [textContingencia, setTextContingencia] = useState("");
  const [RBDList, setRBDList] = useState([""]);
  const [rbdLoading, setRbdLoading] = useState(false);

  const [submitConfirm, setSubmitConfirm] = useState(false);
  const [loadingButton, setLoadingButton] = useState(false);
  const [loading, setLoading] = useState(true);
  const [loadingPdf, setLoadingPdf] = useState(false);
  const [eesData, setEesData] = useState(null);
  const [autoCompleteInput, setAutoCompleteInput] = useState("");
  const [operadorData, setOperadorData] = useState({
    operator_name: "",
    id_operador: "",
  });
  const autoCompleteRef = useRef(null);
  const datetimeRef = useRef(null);
  const datePRef = useRef(null);
  const timePRef = useRef(null);
  const daysPRef = useRef(null);

  const [error, setError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setEvidence();
    setAutoCompleteInputZonas("");
    setAutoCompleteInput("");
    setTypeContingencia(null);
    setSubtypeContingencia(null);
    setTypeId(null);
    setFormData(getEmptyData());
    setOpen(false);
  };
  const navigate = useNavigate();
  const [modalError, setModalError] = useState(false);
  const [modalContent, setModalContent] = useState("");

  const rutRef = useRef(null);
  const evidenceRef = useRef(null);
  const zonasRef = useRef(null);
  const [evError, setEvError] = useState(false);
  const [errorRut, setErrorRut] = useState(false);
  const [evidence, setEvidence] = useState();
  const [autoCompleteInputZonas, setAutoCompleteInputZonas] = useState("");

  const contingenciasRef = useRef();
  const [formData, setFormData] = useState(getEmptyData());
  const [zonas, setZonas] = useState([]);
  const [zonaData, setZonaData] = useState({});
  const [countArray, setCountArray] = useState(1);

  const [blockedRanges, setBlockedRanges] = useState([]); 
  const [blockModalOpen, setBlockModalOpen] = useState(false);
  const [blockModalMessage, setBlockModalMessage] = useState("");

  const yearEndLimit = dayjs().endOf("year");

  const handleDeleteRbd = (zonaIndex, rbdIndex) => {
    setFormData((prev) => {
      const zonas = [...(prev?.zonas ?? [])];
      const zona = zonas[zonaIndex];
      if (!zona) return prev;

      const rbd_list = Array.isArray(zona.rbd_list) ? [...zona.rbd_list] : [];
      rbd_list.splice(rbdIndex, 1);

      if (rbd_list.length === 0) {
        zonas.splice(zonaIndex, 1);
      } else {
        zonas[zonaIndex] = { ...zona, rbd_list };
      }

      return { ...prev, zonas };
    });
  };

  const getBajaDateStr = (data, format = "YYYY-MM-DD") => {
    const estado = String(data?.estado_conectividad ?? data?.estado ?? "")
      .trim()
      .toLowerCase();
    if (estado !== "baja") return null;

    const raw = data?.fecha_baja;
    if (!raw) return null;

    const d = dayjs(raw);
    console.log(d);
    if (!d.isValid()) return null;

    return d.format(format);
  };

  const [bajaDate, setBajaDate] = useState(null);

  function getEmptyData() {
    return {
      name_emisor: userSesion.nombre,
      rut_emisor: userSesion.rut,
      nombre_colegio: "",
      id_operador: "",
      id_zona: "",
      region: "",
      comuna: "",
      operator_name: "",
      rbd: "",
      ees_managers: ["", ""],
      ees_managers_email: ["", ""],
      ees_temporal_manager_list: [""],
      ees_temporal_manager: "",
      ees_temporal_manager_email: "",
      ees_temporal_manager_nombres: "",
      ees_temporal_manager_apellidos: "",
      checked: false,
      contingencia_programada: false,
      programada_descripcion: "",
      region: "",
      region: "",
      programada_inicio_contingencia: dayjs(),
      programada_fin_contingencia: dayjs(),
      programada_hora_inicio: dayjs().hour(0).minute(0),
      programada_hora_termino: dayjs().hour(23).minute(59),
      especifica_fecha_hora_resolucion: dayjs(),
      especifica_fecha_hora_ocurrencia: dayjs(),
      especifica_codigo_evento: "",
      especifica_origen_falla: "",
      especifica_extension_falla: "",
      especifica_descripcion_falla: "",
      days: DAYS.reduce((acc, dia) => ({ ...acc, [dia]: false }), {}),
      extension: "rbd",
      zonas: [],
    };
  }

  const handleSelect = ({ id, type, subtype, title, description }) => {
    setTypeContingencia(type);
    setTypeId(id);
    setSubtypeContingencia(subtype);
    setTextContingencia(
      getValueByKey(DEFAULT_ITEMS_CONTINGENCIAS, "id", id, "description")
    );

    if (type === "ESPECIFICA") {
      setFormData({
        ...formData,
        contingencia_programada: false,
        extension: "rbd",
      });
    } else if (type === "PROGRAMADA") {
      setFormData({
        ...formData,
        contingencia_programada: true,
        especifica_extension_falla: "Solo EES",
        extension: "rbd",
      });
    } else if (type === "ZONAL") {
      setFormData({
        ...formData,
        contingencia_programada: false,
        especifica_extension_falla: "Evento mayor",
        extension: "zona",
      });
    }

    setFormData((prevFormData) => ({
      ...prevFormData,
      operator_name: operadorData.operator_name,
      especifica_origen_falla: subtype,
      id_operador: operadorData.id_operador,
    }));
  };

  const handleChange = (event, newValue) => {
    if (newValue === "zona") {
      setFormData({
        ...formData,
        extension: newValue,
        contingencia_programada: false,
        especifica_extension_falla: "Evento mayor",
      });
    } else {
      setFormData({ ...formData, extension: newValue });
    }
  };

  function getAllZones(id) {
    const fetchDataZone = async (id) => {
      try {
        const response = await axios.getZonasOperador(id);
        const newZonas = response.data.zonas.map((zona) => ({
          ...zona,
          nombre_zona: `ZONA${String(zona.id_zona).padStart(2, "0")}`,
        }));
        setZonas(newZonas);
      } catch (error) {
        console.error("Error en fetchDataZone:", error);
      }
    };
    fetchDataZone(id);
  }

  const handleDeleteRow = (index) => {
    setFormData((prevState) => ({
      ...prevState,
      zonas: prevState.zonas.filter((_, i) => i !== index),
    }));
  };

  const handleAddRowZonas = () => {
    if (!autoCompleteInputZonas) return;

    const newZona = zonas.find(
      (zona) => zona.nombre_zona === autoCompleteInputZonas
    );
    if (!newZona) return;

    setFormData((prev) => {
      const prevZonas = Array.isArray(prev?.zonas) ? [...prev.zonas] : [];
      const idx = prevZonas.findIndex((z) => z.id_zona === newZona.id_zona);

      if (idx === -1) {
        return {
          ...prev,
          zonas: [
            ...prevZonas,
            { ...newZona, rbd_list: [...(newZona?.rbd_list ?? [])] },
          ],
        };
      }

      const zonaActual = prevZonas[idx] ?? {};
      const actuales = Array.isArray(zonaActual.rbd_list)
        ? [...zonaActual.rbd_list]
        : [];
      const entrantes = Array.isArray(newZona.rbd_list) ? newZona.rbd_list : [];

      const yaTiene = new Set(actuales.map((x) => String(x)));
      const faltantes = [];
      for (const rbd of entrantes) {
        const k = String(rbd);
        if (!yaTiene.has(k)) {
          yaTiene.add(k);
          faltantes.push(rbd);
        }
      }

      if (faltantes.length === 0) {
        return prev;
      }

      const rbdUnidos = [...actuales, ...faltantes];
      prevZonas[idx] = { ...zonaActual, rbd_list: rbdUnidos };

      return { ...prev, zonas: prevZonas };
    });

    setAutoCompleteInputZonas("");
  };

  const [errorMessages, setErrorMessages] = useState({
    especifica_fecha_hora_ocurrencia: "",
    especifica_fecha_hora_resolucion: "",
  });

  const setFile = (archivo) => {
    setEvError(
      !archivo &&
        !formData.contingencia_programada &&
        formData.extension == "rbd" &&
        formData.especifica_origen_falla == "Falla externa al adjudicatario"
        ? true
        : false
    );
    setEvidence((prevData) => ({
      ...prevData,
      archivo,
    }));
  };

  const handleSwitch = (event) => {
    setFormData({ ...formData, ["checked"]: event.target.checked });
  };
  const handleErrorChange = (error) => {
    console.log(error);
    setErrorRut(error);
  };

  const validateForm = () => {
    let valid = true;
    const errors = {};

    if (errorRut) {
      rutRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
      return;
    }

    const isProgramada = formData.contingencia_programada;
    const fechaInicioKey = isProgramada
      ? "programada_inicio_contingencia"
      : "especifica_fecha_hora_ocurrencia";
    const fechaFinKey = isProgramada
      ? "programada_fin_contingencia"
      : "especifica_fecha_hora_resolucion";

    const startOfMonth = dayjs().subtract(1, "month").startOf("month");

    const hasBajaLimit = !!bajaDate && typeContingencia !== "ZONAL";
    const bajaLimit = hasBajaLimit ? dayjs(bajaDate).endOf("day") : null;

    const bajaDiaStr = hasBajaLimit ? dayjs(bajaDate).format("DD-MM-YYYY") : null;

    const mensajes = {
      inicioInvalida: `La ${
        isProgramada ? "fecha de inicio" : "fecha de ocurrencia"
      } es inválida.`,
      inicioFuturo: `La ${
        isProgramada ? "fecha de inicio" : "fecha de ocurrencia"
      } no puede ser una fecha futura.`,
      inicioAntesDelMes: `La ${
        isProgramada ? "fecha de inicio" : "fecha de ocurrencia"
      } debe ser igual o posterior al primer día del mes anterior.`,
      inicioSobreBaja: hasBajaLimit
        ? `La ${
            isProgramada ? "fecha de inicio" : "fecha de ocurrencia"
          } no puede ser posterior a la baja (${bajaDiaStr}).`
        : "",
      finInvalida: `La ${
        isProgramada ? "fecha de término" : "fecha de solución"
      } es inválida.`,
      finAntesInicio: `La ${
        isProgramada ? "fecha de término" : "fecha de solución"
      } debe ser posterior a la ${
        isProgramada ? "fecha de inicio" : "fecha de ocurrencia"
      }.`,
      finAntesDelMes: `La ${
        isProgramada ? "fecha de término" : "fecha de solución"
      } debe ser igual o posterior al primer día del mes anterior.`,
      finSobreBaja: hasBajaLimit
        ? `La ${
            isProgramada ? "fecha de término" : "fecha de solución"
          } no puede ser posterior a la baja (${bajaDiaStr}).`
        : "",
    };

    const vIni = formData[fechaInicioKey]
      ? dayjs(formData[fechaInicioKey])
      : null;

    if (!vIni || !vIni.isValid()) {
      errors[fechaInicioKey] = mensajes.inicioInvalida;
      valid = false;
    } else if (vIni.isBefore(startOfMonth)) {
      errors[fechaInicioKey] = mensajes.inicioAntesDelMes;
      valid = false;
    } else if (vIni.isAfter(dayjs()) && !isProgramada) {
      errors[fechaInicioKey] = mensajes.inicioFuturo;
      valid = false;
    } else if (hasBajaLimit && vIni.isAfter(bajaLimit)) {
      errors[fechaInicioKey] = mensajes.inicioSobreBaja;
      valid = false;
    }

    const vFin = formData[fechaFinKey]
      ? dayjs(formData[fechaFinKey])
      : null;

    if (!vFin || !vFin.isValid()) {
      errors[fechaFinKey] = mensajes.finInvalida;
      valid = false;
    } else if (vIni && vFin.isBefore(vIni)) {
      errors[fechaFinKey] = mensajes.finAntesInicio;
      valid = false;
    } else if (vFin.isBefore(startOfMonth)) {
      errors[fechaFinKey] = mensajes.finAntesDelMes;
      valid = false;
    } else if (vFin.isAfter(dayjs()) && !isProgramada) {
      errors[fechaFinKey] = mensajes.inicioFuturo;
      valid = false;
    } else if (hasBajaLimit && vFin.isAfter(bajaLimit)) {
      errors[fechaFinKey] = mensajes.finSobreBaja;
      valid = false;
    }

    if (isProgramada) {

      if (vIni && vIni.isAfter(yearEndLimit)) {
        errors[fechaInicioKey] =
          "La fecha de inicio no puede ser posterior al 31-12 del año en curso.";
        valid = false;
      }

      if (vFin && vFin.isAfter(yearEndLimit)) {
        errors[fechaFinKey] =
          "La fecha de término no puede ser posterior al 31-12 del año en curso.";
        valid = false;
      }
    }

    if (
      isProgramada &&
      dayjs(formData["programada_hora_inicio"]).isAfter(
        formData["programada_hora_termino"]
      )
    ) {
      errors["programada_hora_termino"] =
        "La hora de termino debe ser posterior a la de inicio";
      valid = false;
      timePRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
    } else if (
      isProgramada &&
      !Object.values(formData.days).some((value) => value)
    ) {
      errors["days"] = "Debe seleccionar al menos un día";
      daysPRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
      valid = false;
    } else if (
      formData.ees_managers[0] === "Sin representante" &&
      formData.especifica_origen_falla === "Falla interna al adjudicatario" &&
      !formData.checked
    ) {
      setFormData((prev) => ({ ...prev, checked: true }));
      rutRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
      valid = false;
    } else if (!valid) {
      if (isProgramada) {
        datePRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      } else {
        datetimeRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }

    if (formData.extension === "zona" && formData.zonas.length === 0) {
      errors["zonas"] = "Debe agregar al menos una zona";
      zonasRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
      valid = false;
    }
    console.log(errors);

    setErrorMessages(errors);
    return valid;
  };

  // --- Helper: rango [start, end] de la contingencia según tipo ---
  const getContingenciaRange = () => {
    if (typeContingencia === "PROGRAMADA") {
      const inicioFecha = formData.programada_inicio_contingencia;
      const finFecha = formData.programada_fin_contingencia;

      if (!inicioFecha || !finFecha) return null;

      const inicioHora = formData.programada_hora_inicio;
      const finHora = formData.programada_hora_termino;

      const start = dayjs(inicioFecha)
        .hour(inicioHora ? dayjs(inicioHora).hour() : 0)
        .minute(inicioHora ? dayjs(inicioHora).minute() : 0)
        .second(0);

      const end = dayjs(finFecha)
        .hour(finHora ? dayjs(finHora).hour() : 23)
        .minute(finHora ? dayjs(finHora).minute() : 59)
        .second(59);

      if (!start.isValid() || !end.isValid()) return null;
      return { start, end };
    }

    const start = formData.especifica_fecha_hora_ocurrencia
      ? dayjs(formData.especifica_fecha_hora_ocurrencia)
      : null;
    const end = formData.especifica_fecha_hora_resolucion
      ? dayjs(formData.especifica_fecha_hora_resolucion)
      : null;

    if (!start || !end || !start.isValid() || !end.isValid()) return null;
    return { start, end };
  };

  // --- Helper: ¿el rango está totalmente contenido en algún rango bloqueado? ---
  const isContingenciaInsideBlockedRange = () => {
    if (!blockedRanges || blockedRanges.length === 0) return false;

    const range = getContingenciaRange();
    if (!range) return false;

    const { start, end } = range;

    return blockedRanges.some((b) => {
      const rawStart = b.inicio || b.start;
      const rawEnd = b.fin || b.end;

      if (!rawStart || !rawEnd) return false;

      const bStart = dayjs(rawStart);
      const bEnd = dayjs(rawEnd);

      if (!bStart.isValid() || !bEnd.isValid()) return false;

      const startOk = start.isAfter(bStart) || start.isSame(bStart);
      const endOk = end.isBefore(bEnd) || end.isSame(bEnd);

      return startOk && endOk;
    });
  };
  const handleRangesChange = useCallback((ranges) => {
  setBlockedRanges(ranges);
}, []);
  function getOperator() {
    axios
      .getOperator(userSesion.rut)
      .then((response) => {
        setOperadorData((prevFormData) => ({
          ...prevFormData,
          operator_name: response.data.operador,
          id_operador: response.data.id_operador + "",
        }));
        setFormData((prevFormData) => ({
          ...prevFormData,
          operator_name: response.data.operador,
          id_operador: response.data.id_operador + "",
        }));

        getAllZones(response.data.id_operador);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error al obtener el operador:", error);
        setLoading(false);
      });
  }

  function getEes(rbd_list) {
    if (autoCompleteInput !== "") {
      const rbd_temp = autoCompleteInput;
      if (rbd_list.includes(rbd_temp)) {
        axios
          .getEesData(rbd_temp, "1")
          .then((response) => {
            const tempRep = response.data.nombres_representantes;

            const tempEmails = response.data.email_representantes;

            setFormData((prevFormData) => ({
              ...prevFormData,
              nombre_colegio: response.data.nombre_colegio,
              region: response.data.region,
              comuna: response.data.comuna,
              ees_managers:
                tempRep.length > 0 ? tempRep : ["Sin representante"],
              ees_managers_email: tempEmails.length > 0 ? tempEmails : [""],
              ees_temporal_manager_list:
                response.data.nombres_representantes_temporales.length > 0
                  ? response.data.nombres_representantes_temporales
                  : ["Sin representante"],
              id_zona: response.data.id_zona + "",
            }));

            setBajaDate(getBajaDateStr(response.data));
            const max = Math.max(tempRep.length ?? 0, tempEmails.length ?? 0);
            setCountArray(max > 0 ? max : 1);
            setError(false);
            setErrorMsg("");
          })
          .catch((error) => {
            console.error("Error al obtener datos del EES:", error);

            setFormData((prevFormData) => ({
              ...prevFormData,
              nombre_colegio: "Colegio no encontrado",
              ees_managers: ["Colegio no encontrado"],
              ees_temporal_manager_list: ["Sin representante"],
              region: "",
              comuna: "",
              ees_managers_email: [""],
              id_zona: "",
            }));

            setError(true);
            setErrorMsg("Colegio no encontrado");
            setCountArray(1);
            setBajaDate(null);
          });
      } else {
        setFormData((prevFormData) => ({
          ...prevFormData,
          nombre_colegio: "Colegio no encontrado",
          ees_managers: ["Colegio no encontrado"],
          region: "",
          comuna: "",
          ees_managers_email: [""],
          ees_temporal_manager_list: ["Sin representante"],
          id_zona: "",
        }));
        setBajaDate(null);
        setCountArray(1);
        setError(true);
        setErrorMsg("Colegio no encontrado");
      }
    }
  }

  const save = async (event) => {
    event.preventDefault();
    if (loadingButton) return;
    setLoadingButton(true);

    if (!submitConfirm) {
      setSubmitConfirm(!submitConfirm);
      setLoadingButton(false);
      return;
    }

    if (
      !evidence &&
      ((!formData.contingencia_programada &&
        formData.extension == "rbd" &&
        formData.especifica_origen_falla == "Falla externa al adjudicatario") ||
        formData.extension == "zona")
    ) {
      setEvError(
        !evidence &&
          ((!formData.contingencia_programada &&
            formData.extension == "rbd" &&
            formData.especifica_origen_falla ==
              "Falla externa al adjudicatario") ||
            formData.extension == "zona")
          ? true
          : false
      );
      evidenceRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
      setLoadingButton(false);
      return;
    }
    if (error) {
      autoCompleteRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
      setLoadingButton(false);
      return;
    }

    setLoading(true);

    if (validateForm()) {
  if (isContingenciaInsideBlockedRange()) {
    const { start, end } = getContingenciaRange();

    const startStr = start
      ? dayjs(start).format("YYYY-MM-DD HH:mm")
      : "";
    const endStr = end
      ? dayjs(end).format("YYYY-MM-DD HH:mm")
      : "";

    const rangesStr =
      blockedRanges && blockedRanges.length > 0
        ? blockedRanges
            .map((r) => {
              const rs = dayjs(r.inicio || r.start).format(
                "YYYY-MM-DD HH:mm"
              );
              const re = dayjs(r.fin || r.end).format(
                "YYYY-MM-DD HH:mm"
              );
              return `• ${rs} a ${re}`;
            })
            .join("\n")
        : "- (sin rangos configurados)";

    setBlockModalMessage(
  `El intervalo de tiempo seleccionado para la contingencia (${startStr} a ${endStr}) ` +
    `se encuentra dentro de un periodo no afecto a descuento, por lo que no es necesario crear una contingencia para el periodo. \n` +
    `Los Periodos no afectos a descuentos registrados son:\n${rangesStr}`
);

    setBlockModalOpen(true);
    setLoading(false);
    setLoadingButton(false);
    return;
  }

  handleDownloadPdf();
} else {
  setLoading(false);
  setLoadingButton(false);
}
  };

  const handleDownloadPdf = () => {
    const element = contingenciasRef.current;
    setLoadingPdf(true);

    setTimeout(() => {
      const element = contingenciasRef.current;

      html2canvas(element, { scale: 2 })
        .then((canvas) => {
          setLoading(true);
          const imageData = canvas.toDataURL("image/jpeg", 1);

          const pdfWidth = 210;
          const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
          const pdf = new jsPDF("p", "mm", [pdfWidth, pdfHeight + 7]);

          pdf.setFillColor(255, 255, 255);
          pdf.rect(0, 0, pdfWidth, pdfHeight + 140, "F");
          pdf.addImage(imageData, "JPEG", 0, 0, pdfWidth, pdfHeight);

          const pdfBlob = pdf.output("blob");

          const form = new FormData();
          const localFormData = {
            ...formData,
            rbd: autoCompleteInput ? autoCompleteInput : "",
            especifica_fecha_hora_ocurrencia: formData[
              "especifica_fecha_hora_ocurrencia"
            ]
              ? formData["especifica_fecha_hora_ocurrencia"]
                  .locale("es")
                  .format("YYYY/MM/DD HH:mm:ss")
                  .toString()
              : null,
            especifica_fecha_hora_resolucion: formData[
              "especifica_fecha_hora_resolucion"
            ]
              ? formData["especifica_fecha_hora_resolucion"]
                  .locale("es")
                  .format("YYYY/MM/DD HH:mm:ss")
                  .toString()
              : null,
            programada_inicio_contingencia: formData[
              "programada_inicio_contingencia"
            ]
              ? formData["programada_inicio_contingencia"]
                  .locale("es")
                  .format("YYYY/MM/DD")
                  .toString()
              : null,
            programada_fin_contingencia: formData["programada_fin_contingencia"]
              ? formData["programada_fin_contingencia"]
                  .locale("es")
                  .format("YYYY/MM/DD")
                  .toString()
              : null,
            programada_hora_inicio: formData["programada_hora_inicio"]
              ? formData["programada_hora_inicio"]
                  .locale("es")
                  .format("HH:mm:ss")
                  .toString()
              : null,
            programada_hora_termino: formData["programada_hora_termino"]
              ? formData["programada_hora_termino"]
                  .locale("es")
                  .format("HH:mm:ss")
                  .toString()
              : null,
            evidence_list:
              evidence && evidence.archivo ? [evidence.archivo] : [],
          };

          form.append("data", JSON.stringify(localFormData));

          for (let i = 0; i < localFormData["evidence_list"].length; i++) {
            form.append("evidence", localFormData["evidence_list"][i]);
          }

          form.append("file", pdfBlob, "temp.pdf");

          axios
            .sendFilesContingencias(form)
            .then((response) => {
              setLoading(false);
              setModalError(false);
              setModalContent(
                "Documento enviado y firmado. Folio: " +
                  String(response.data.message?.id).padStart(8, "0")
              );
              setOpen(true);
            })
            .catch((error) => {
              setModalError(true);
              setModalError("La creación del documento falló");
              setLoading(false);
            });
          setLoadingPdf(false);
          setSubmitConfirm(false);
          setLoadingButton(false);
        })
        .catch((error) => {
          console.error("Error generando el PDF:", error);
          setLoadingPdf(false);
          setLoading(false);
          setSubmitConfirm(false);
          setLoadingButton(false);
        });
    }, 0);
  };

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      days: {
        ...prevFormData.days,
        [name]: checked,
      },
    }));
    setErrorMessages((prevErrorMessages) => ({
      ...prevErrorMessages,
      days: null,
    }));
  };

  function getRBD() {
    if (autoCompleteInput !== "") {
      let rbd_temp = autoCompleteInput;
      setRbdLoading(true);
      axios
        .getRBDOperador(rbd_temp, formData.id_operador)
        .then((response) => {
          setRBDList(response.data.rbd_list);
          setRbdLoading(false);
          setError(false);
          setErrorMsg("");
          getEes(response.data.rbd_list);
        })
        .catch((error) => {
          setRbdLoading(true);
          setError("Colegio no encontrado");
        });
    }
  }

  useEffect(() => {
    setFormData({
      ...formData,
      rbd: autoCompleteInput ? autoCompleteInput : "",
    });
    getRBD();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [autoCompleteInput]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  useEffect(() => {
    getOperator();
    setDrawerHidding(false);
  }, [setPageTitle, setDrawerHidding]);



  const extensionOptions = useMemo(() => {
    if (formData.especifica_origen_falla === "Falla interna al adjudicatario") {
      return [{ value: "Solo EES", label: "Solo EES" }];
    }
    if (formData.especifica_origen_falla === "Falla externa al adjudicatario") {
      return [
        { value: "Solo EES", label: "Solo EES" },
        { value: "Evento mayor", label: "Evento mayor" },
      ];
    }
    return [];
  }, [formData.especifica_origen_falla]);

  const codigoOptions = useMemo(() => {
    if (formData.especifica_origen_falla === "Falla interna al adjudicatario") {
      return [
        { value: "15", label: "15 - Corte de energía EES" },
        { value: "18", label: "18 - Otro responsabilidad de terceros" },
      ];
    }
    if (formData.especifica_origen_falla === "Falla externa al adjudicatario") {
      return [
        { value: "16", label: "16 - Corte suministro público energía" },
        { value: "18", label: "18 - Otro responsabilidad de terceros" },
      ];
    }
    return [];
  }, [formData.especifica_origen_falla]);

  useEffect(() => {
    if (
      formData.especifica_extension_falla &&
      !extensionOptions.some(
        (opt) => opt.value === formData.especifica_extension_falla
      )
    ) {
      setFormData({
        ...formData,
        especifica_extension_falla: "",
        especifica_codigo_evento: "",
      });
      return;
    }
    if (
      formData.especifica_codigo_evento &&
      !codigoOptions.some(
        (opt) => opt.value === formData.especifica_codigo_evento
      )
    ) {
      setFormData({
        ...formData,
        especifica_codigo_evento: "",
      });
    }
  }, [formData.especifica_origen_falla, extensionOptions, codigoOptions]);

  return (
    <>
      <PageBody>
        <PageBgBlock pad="0">
          {loading ? (
            <HourglassLoader />
          ) : (
            <>

<PeriodosGraciaAlert
  idOperador={formData.id_operador}
  periodoActual={dayjs().startOf("month")}
  onRangesChange={handleRangesChange}
/>

              {!typeContingencia ? (
                <ContingenciasSelection onSelect={handleSelect} />
              ) : (
                <>
                  <Box
                    sx={{
                      paddingLeft: "9rem",
                      paddingRight: "9rem",
                      paddingTop: "2rem",
                    }}
                  >
                    <Typography
                      variant="h1"
                      align="center"
                      sx={{ marginBottom: "0.24rem" }}
                    >
                      {getValueByKey(
                        DEFAULT_ITEMS_CONTINGENCIAS,
                        "id",
                        typeId,
                        "title"
                      )}
                    </Typography>
                    <Stack
                      alignItems="left"
                      justifyContent="center"
                      spacing={2}
                    >
                      <Box
                        justifyContent="center"
                        sx={{ display: "flex", margin: "0.2rem!important" }}
                      >
                        <Typography
                          variant="small"
                          color="inherit"
                          sx={{
                            textAlign: "center",
                            justifyContent: "center",
                            paddingY: "0",
                            marginTop: "0",
                          }}
                        >
                          N° folio:{" "}
                          <Typography
                            variant="small"
                            sx={{
                              paddingLeft: "1rem",
                              marginTop: "0",
                              color: "#FFF",
                            }}
                          >
                            {String("").padStart(8, "0")}
                          </Typography>
                        </Typography>
                      </Box>

                      <Box
                        justifyContent="center"
                        sx={{
                          maxWidth: "100%",
                          margin: "0 auto",
                          display: "flex",
                        }}
                      >
                        <Typography
                          variant="body"
                          align="center"
                          sx={{ marginBottom: "2rem" }}
                        >
                          {parseBoldText(textContingencia)}
                        </Typography>
                      </Box>
                    </Stack>

                    <form onSubmit={save} id="contingencia">
                      <Stack spacing={4} sx={{ marginBottom: "2rem" }}>
                        <Typography
                          variant="h3"
                          color="inherit"
                          noWrap
                          sx={{ flexGrow: 1 }}
                        >
                          DATOS DEL EMISOR
                        </Typography>

                        <Grid container spacing={2}>
                          <Grid size={6}>
                            <FormControl fullWidth variant="outlined">
                              <TextField
                                test_id={toSnakeCase("rut_emisor")}
                                disabled
                                required
                                name="rut"
                                label="Rut Operador Administrador"
                                size="small"
                                value={formData.rut_emisor}
                                onChange={handleInputChange}
                              />
                            </FormControl>
                          </Grid>
                          <Grid size={6}>
                            <FormControl fullWidth variant="outlined">
                              <TextField
                                test_id={toSnakeCase("name_emisor")}
                                disabled
                                required
                                name="nombre"
                                label="Nombre y Apellido"
                                size="small"
                                value={formData.name_emisor}
                                onChange={handleInputChange}
                              />
                            </FormControl>
                          </Grid>
                        </Grid>

                        <Typography
                          variant="h3"
                          color="inherit"
                          noWrap
                          sx={{ flexGrow: 1 }}
                        >
                          DATOS DEL OPERADOR
                        </Typography>

                        <Grid container spacing={2}>
                          <Grid size={6}>
                            <FormControl fullWidth variant="outlined">
                              <TextField
                                test_id={toSnakeCase("id_operador")}
                                disabled
                                required
                                name="id_operador"
                                label="ID Operador"
                                size="small"
                                value={formData.id_operador}
                                onChange={handleInputChange}
                              />
                            </FormControl>
                          </Grid>
                          <Grid size={6}>
                            <FormControl fullWidth variant="outlined">
                              <TextField
                                test_id={toSnakeCase("operator_name")}
                                disabled
                                required
                                name="operator_name"
                                label="Nombre Operador"
                                size="small"
                                value={formData.operator_name}
                                onChange={handleInputChange}
                              />
                            </FormControl>
                          </Grid>
                        </Grid>

                        <Typography
                          variant="h3"
                          color="inherit"
                          noWrap
                          sx={{ flexGrow: 1 }}
                        >
                          DATOS BASE DE JUSTIFICACIÓN DE INDISPONIBILIDAD
                        </Typography>

                        <Grid container spacing={2}>
                          <Grid size={12}>
                            <FormControl sx={{ width: "100%" }} size="small">
                              <InputLabel
                                id="especifica_origen_falla-label"
                                sx={{ backgroundColor: "#fff" }}
                              >
                                Origen del corte
                                {formData.extension === "rbd" &&
                                !formData.contingencia_programada
                                  ? "*"
                                  : ""}
                              </InputLabel>
                              <Select
                                test_id={toSnakeCase("especifica_origen_falla")}
                                required={
                                  formData.extension === "rbd" &&
                                  !formData.contingencia_programada
                                }
                                disabled
                                labelId="especifica_origen_falla-label"
                                id="especifica_origen_falla"
                                value={formData.especifica_origen_falla}
                                label="Origen del corte"
                                size="small"
                                sx={{ width: "100%" }}
                                onChange={(event) =>
                                  setFormData({
                                    ...formData,
                                    especifica_origen_falla: event.target.value,
                                  })
                                }
                              >
                                <MenuItem
                                  test_id={toSnakeCase(
                                    "menu_especifica_origen_falla_0"
                                  )}
                                  value={"Falla interna al adjudicatario"}
                                >
                                  Evento interno al establecimiento
                                </MenuItem>
                                <MenuItem
                                  test_id={toSnakeCase(
                                    "menu_especifica_origen_falla_1"
                                  )}
                                  value={"Falla externa al adjudicatario"}
                                >
                                  Evento externo al establecimiento
                                </MenuItem>
                              </Select>
                            </FormControl>
                          </Grid>

                          {false && (
                            <Grid size={12}>
                              <FormControl fullWidth size="small">
                                <InputLabel
                                  id="especifica_extension_falla-label"
                                  sx={{ backgroundColor: "#fff", px: 0.5 }}
                                >
                                  Extensión de la falla
                                  {formData.extension === "rbd" &&
                                  !formData.contingencia_programada
                                    ? "*"
                                    : ""}
                                </InputLabel>
                                <Select
                                  test_id={toSnakeCase(
                                    "especifica_extension_falla"
                                  )}
                                  required={
                                    formData.extension === "rbd" &&
                                    !formData.contingencia_programada
                                  }
                                  disabled={
                                    formData.contingencia_programada ||
                                    formData.especifica_origen_falla === ""
                                  }
                                  labelId="especifica_extension_falla-label"
                                  id="especifica_extension_falla"
                                  value={formData.especifica_extension_falla}
                                  label="Extensión de la falla"
                                  size="small"
                                  onChange={(event) =>
                                    setFormData({
                                      ...formData,
                                      especifica_extension_falla:
                                        event.target.value,
                                    })
                                  }
                                >
                                  {extensionOptions.map((opt, index) => (
                                    <MenuItem
                                      test_id={toSnakeCase(
                                        "menu_especifica_extension_falla_" +
                                          index
                                      )}
                                      key={opt.value}
                                      value={opt.value}
                                    >
                                      {opt.label}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </Grid>
                          )}

                          {typeContingencia !== "PROGRAMADA" && (
                            <Grid size={12}>
                              <FormControl fullWidth size="small">
                                <InputLabel
                                  id="especifica_codigo_evento-label"
                                  sx={{ backgroundColor: "#fff", px: 0.5 }}
                                >
                                  Código de evento
                                  {formData.extension === "rbd" &&
                                  !formData.contingencia_programada
                                    ? "*"
                                    : ""}
                                </InputLabel>
                                <Select
                                  test_id={toSnakeCase(
                                    "especifica_codigo_evento"
                                  )}
                                  required={
                                    formData.extension === "rbd" &&
                                    !formData.contingencia_programada
                                  }
                                  disabled={
                                    formData.especifica_origen_falla === "" ||
                                    typeContingencia === "PROGRAMADA"
                                  }
                                  labelId="especifica_codigo_evento-label"
                                  id="especifica_codigo_evento"
                                  value={formData.especifica_codigo_evento}
                                  label="Código de evento"
                                  size="small"
                                  onChange={(event) =>
                                    setFormData({
                                      ...formData,
                                      especifica_codigo_evento:
                                        event.target.value,
                                    })
                                  }
                                >
                                  {codigoOptions.map((opt, index) => (
                                    <MenuItem
                                      test_id={toSnakeCase(
                                        "menu_especifica_codigo_evento_" +
                                          opt.value
                                      )}
                                      key={opt.value}
                                      value={opt.value}
                                    >
                                      {opt.label}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </Grid>
                          )}
                        </Grid>

                        {typeContingencia === "ZONAL" && (
                          <>
                            <Typography
                              variant="h3"
                              color="inherit"
                              noWrap
                              sx={{ flexGrow: 1 }}
                            >
                              DATOS DE LA ZONA
                            </Typography>

                            <Grid container spacing={2}>
                              <Grid size={9}>
                                <FormControl sx={{ minWidth: "100%" }}>
                                  <Autocomplete
                                    test_id={toSnakeCase("Autocomplete_zona")}
                                    value={
                                      zonas.find(
                                        (zona) =>
                                          zona.nombre_zona ===
                                          autoCompleteInputZonas
                                      ) || null
                                    }
                                    onChange={(event, newValue) => {
                                      console.log(newValue);
                                      setAutoCompleteInputZonas(
                                        newValue ? newValue.nombre_zona : ""
                                      );
                                      if (newValue) {
                                        setZonaData(newValue);
                                      }
                                    }}
                                    disablePortal
                                    loading={rbdLoading}
                                    loadingText="Cargando..."
                                    options={zonas || []}
                                    getOptionLabel={(option) =>
                                      option?.nombre_zona || ""
                                    }
                                    isOptionEqualToValue={(option, value) =>
                                      option?.id_zona === value?.id_zona
                                    }
                                    size="small"
                                    autoComplete
                                    renderInput={(params) => (
                                      <TextField
                                        test_id={toSnakeCase("Zona")}
                                        {...params}
                                        error={error}
                                        helperText={errorMsg}
                                        label="Zona"
                                        placeholder="Buscar zona"
                                        InputProps={{
                                          ...params.InputProps,
                                          startAdornment: (
                                            <>
                                              {params.InputProps.startAdornment}
                                              <TuneIcon />
                                            </>
                                          ),
                                        }}
                                      />
                                    )}
                                  />
                                </FormControl>
                              </Grid>
                              <Grid item size={3}>
                                <PageButtonSimple
                                  pad=".5rem"
                                  width="auto"
                                  onClick={handleAddRowZonas}
                                  startIcon={
                                    <AddCircleOutlineOutlinedIcon />
                                  }
                                  disabled={
                                    !autoCompleteInputZonas || rbdLoading
                                  }
                                >
                                  Agregar a la lista
                                </PageButtonSimple>
                              </Grid>

                              <Grid size={12}>
                                <TableContainer
                                  component={Paper}
                                  sx={{ mb: 2, mt: 2 }}
                                >
                                  <Table ref={zonasRef}>
                                    <TableHead>
                                      <TableRow>
                                        <TableCell sx={{ width: "80px" }}>
                                          <IconButton
                                            test_id={toSnakeCase("delete")}
                                            onClick={() =>
                                              setFormData((prevState) => ({
                                                ...prevState,
                                                zonas: [],
                                              }))
                                            }
                                          >
                                            <RemoveCircleOutlineIcon />
                                          </IconButton>
                                        </TableCell>
                                        <TableCell sx={{ width: "80px" }}>
                                          Id Zona
                                        </TableCell>
                                        <TableCell>RBDs</TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {formData.zonas.length > 0 ? (
                                        formData.zonas.map((zona, index) => (
                                          <TableRow key={index}>
                                            <TableCell>
                                              <IconButton
                                                test_id={toSnakeCase(
                                                  "delete_" + index
                                                )}
                                                onClick={() =>
                                                  handleDeleteRow(index)
                                                }
                                              >
                                                <RemoveCircleOutlineIcon />
                                              </IconButton>
                                            </TableCell>
                                            <TableCell
                                              sx={{ verticalAlign: "middle" }}
                                            >
                                              {zona.id_zona}
                                            </TableCell>
                                            <TableCell
                                              sx={{ verticalAlign: "middle" }}
                                            >
                                              <Box
                                                sx={{
                                                  display: "flex",
                                                  flexWrap: "wrap",
                                                  gap: 0.5,
                                                }}
                                              >
                                                {Array.isArray(zona.rbd_list) &&
                                                zona.rbd_list.length > 0 ? (
                                                  zona.rbd_list.map(
                                                    (rbd, ri) => (
                                                      <Chip
                                                        key={`${zona.id_zona}-${ri}`}
                                                        label={String(rbd)}
                                                        size="small"
                                                        variant="outlined"
                                                        onDelete={() =>
                                                          handleDeleteRbd(
                                                            index,
                                                            ri
                                                          )
                                                        }
                                                        test_id={toSnakeCase(
                                                          `delete_rbd_${index}_${ri}`
                                                        )}
                                                      />
                                                    )
                                                  )
                                                ) : null}
                                              </Box>
                                            </TableCell>
                                          </TableRow>
                                        ))
                                      ) : (
                                        <TableRow>
                                          <TableCell colSpan={4} align="center">
                                            No hay zonas agregadas
                                          </TableCell>
                                        </TableRow>
                                      )}
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                              </Grid>
                            </Grid>
                          </>
                        )}

                        {(typeContingencia === "PROGRAMADA" ||
                          typeContingencia === "ESPECIFICA") && (
                          <>
                            <Typography
                              variant="h3"
                              color="inherit"
                              noWrap
                              sx={{ flexGrow: 1 }}
                            >
                              DATOS DEL RBD
                            </Typography>
                            <Grid container spacing={2}>
                              <Grid size={6}>
                                <Box ref={autoCompleteRef}>
                                  <FormControl sx={{ minWidth: "100%" }}>
                                    <Autocomplete
                                      test_id={toSnakeCase("Autocomplete_rbd")}
                                      key="rbd"
                                      value={autoCompleteInput}
                                      onChange={(event, newValue) => {
                                        setAutoCompleteInput(
                                          newValue ? newValue : ""
                                        );
                                        setFormData({
                                          ...formData,
                                          rbd: newValue ? newValue : "",
                                        });
                                      }}
                                      inputValue={autoCompleteInput}
                                      onInputChange={(event, newValue) => {
                                        setAutoCompleteInput(
                                          newValue ? newValue : ""
                                        );
                                        setFormData({
                                          ...formData,
                                          rbd: newValue ? newValue : "",
                                        });
                                      }}
                                      disablePortal
                                      loading={rbdLoading}
                                      loadingText="Cargando..."
                                      multiple={false}
                                      options={RBDList}
                                      autoComplete
                                      size="small"
                                      renderInput={(params) => {
                                        return (
                                          <TextField
                                            test_id={toSnakeCase("rbd")}
                                            required={
                                              formData.extension === "rbd"
                                            }
                                            error={error}
                                            helperText={errorMsg}
                                            {...params}
                                            label="RBD"
                                          />
                                        );
                                      }}
                                    />
                                  </FormControl>
                                </Box>
                              </Grid>

                              <Grid size={6}>
                                <FormControl fullWidth variant="outlined">
                                  <TextField
                                    test_id={toSnakeCase("id_zona")}
                                    label="ID Zona"
                                    size="small"
                                    disabled
                                    value={formData.id_zona}
                                    sx={{ width: "100%" }}
                                  />
                                </FormControl>
                              </Grid>

                              <Grid size={6}>
                                <FormControl fullWidth variant="outlined">
                                  <TextField
                                    test_id={toSnakeCase("region")}
                                    label="Región"
                                    size="small"
                                    disabled
                                    value={formData.region}
                                    sx={{ width: "100%" }}
                                  />
                                </FormControl>
                              </Grid>

                              <Grid size={6}>
                                <FormControl fullWidth variant="outlined">
                                  <TextField
                                    test_id={toSnakeCase("comuna")}
                                    label="Comuna"
                                    size="small"
                                    disabled
                                    value={formData.comuna}
                                    sx={{ width: "100%" }}
                                  />
                                </FormControl>
                              </Grid>

                              <Grid size={12}>
                                <FormControl fullWidth variant="outlined">
                                  <TextField
                                    test_id={toSnakeCase("nombre_colegio")}
                                    id="outlined"
                                    label="Nombre del Colegio"
                                    size="small"
                                    disabled
                                    value={formData.nombre_colegio}
                                    sx={{ width: "100%" }}
                                  />
                                </FormControl>
                              </Grid>
                              {Array.from({ length: countArray }).map(
                                (_, i) => (
                                  <React.Fragment key={i}>
                                    <Grid size={6}>
                                      <TextField
                                        test_id={toSnakeCase(
                                          `ees_managers_${i}`
                                        )}
                                        label={`Representante del establecimiento ${
                                          i + 1
                                        }`}
                                        size="small"
                                        disabled
                                        value={
                                          formData?.ees_managers?.[i] ?? ""
                                        }
                                        sx={{ width: "100%" }}
                                      />
                                    </Grid>

                                    <Grid size={6}>
                                      <TextField
                                        test_id={toSnakeCase(
                                          `ees_managers_email_${i}`
                                        )}
                                        label={`Email Representante del establecimiento ${
                                          i + 1
                                        }`}
                                        size="small"
                                        disabled
                                        value={
                                          formData?.ees_managers_email?.[i] ??
                                          ""
                                        }
                                        sx={{ width: "100%" }}
                                      />
                                    </Grid>
                                  </React.Fragment>
                                )
                              )}
                            </Grid>

                            {formData.especifica_origen_falla ===
                              "Falla interna al adjudicatario" && (
                              <Grid container spacing={2}>
                                <Grid
                                  sx={{ width: "100%", marginY: 2 }}
                                  size={12}
                                >
                                  <Box ref={rutRef}>
                                    <InputRut
                                      error={errorRut}
                                      errorRut={handleErrorChange}
                                      checked={formData.checked}
                                      rut={formData.ees_temporal_manager}
                                      email={
                                        formData.ees_temporal_manager_email
                                      }
                                      nombre_temp={
                                        formData.ees_temporal_manager_nombres
                                      }
                                      apellido_temp={
                                        formData.ees_temporal_manager_apellidos
                                      }
                                      handleSwitch={handleSwitch}
                                      handleRut={(newValue) =>
                                        setFormData({
                                          ...formData,
                                          ["ees_temporal_manager"]: newValue,
                                        })
                                      }
                                      handleEmail={(newValue) =>
                                        setFormData({
                                          ...formData,
                                          ["ees_temporal_manager_email"]:
                                            newValue,
                                        })
                                      }
                                      handleNombre={(newValue) =>
                                        setFormData({
                                          ...formData,
                                          ["ees_temporal_manager_nombres"]:
                                            newValue,
                                        })
                                      }
                                      handleApellido={(newValue) =>
                                        setFormData({
                                          ...formData,
                                          ["ees_temporal_manager_apellidos"]:
                                            newValue,
                                        })
                                      }
                                      margin="0"
                                    ></InputRut>
                                  </Box>
                                </Grid>
                              </Grid>
                            )}
                          </>
                        )}

                        <Typography variant="h3" color="inherit" noWrap sx={{}}>
                          DETALLE DE LA JUSTIFICACIÓN DE INDISPONIBILIDAD
                        </Typography>

                        {typeContingencia === "PROGRAMADA" && (
                          <FormControl sx={{ width: "100%", spacing: 2 }}>
                            <Grid container spacing={2}>
                              <Grid size={12}>
                                <FormControl
                                  sx={{ width: "100%", maxWidth: "100%" }}
                                >
                                  <TextField
                                    test_id={toSnakeCase(
                                      "programada_descripcion"
                                    )}
                                    required
                                    multiline
                                    minRows={4}
                                    maxRows={30}
                                    id="outlined-required"
                                    label="Descripción de contingencia"
                                    placeholder="Descripción de contingencia"
                                    size="small"
                                    value={formData.programada_descripcion}
                                    onChange={(event) =>
                                      setFormData({
                                        ...formData,
                                        programada_descripcion:
                                          event.target.value,
                                      })
                                    }
                                  />
                                </FormControl>
                              </Grid>

                              <Grid size={12}>
                                <Typography size="body">
                                  Rango horario de ocurrencia
                                </Typography>
                                <Divider></Divider>
                              </Grid>

                              <Grid size={6} ref={timePRef}>
                                <LocalizationProvider
                                  dateAdapter={AdapterDayjs}
                                  adapterLocale="es"
                                >
                                  <TimePicker
                                    test_id={toSnakeCase(
                                      "programada_hora_inicio"
                                    )}
                                    sx={{ width: "100%" }}
                                    label="Hora de inicio"
                                    value={formData.programada_hora_inicio}
                                    onChange={(newValue) =>
                                      setFormData({
                                        ...formData,
                                        programada_hora_inicio: newValue,
                                      })
                                    }
                                    minTime={dayjs().startOf("day")}
                                    minutesStep={1}
                                    slotProps={{
                                      textField: {
                                        required: true,
                                        size: "small",
                                        helperText:
                                          errorMessages.programada_hora_inicio,
                                        error:
                                          !!errorMessages.programada_hora_inicio,
                                      },
                                    }}
                                  />
                                </LocalizationProvider>
                              </Grid>

                              <Grid size={6}>
                                <LocalizationProvider
                                  dateAdapter={AdapterDayjs}
                                  adapterLocale="es"
                                >
                                  <TimePicker
                                    test_id={toSnakeCase(
                                      "programada_hora_termino"
                                    )}
                                    sx={{ width: "100%" }}
                                    label="Hora de término"
                                    value={formData.programada_hora_termino}
                                    minutesStep={1}
                                    onChange={(newValue) =>
                                      setFormData({
                                        ...formData,
                                        programada_hora_termino: newValue,
                                      })
                                    }
                                    minTime={formData.programada_hora_inicio}
                                    slotProps={{
                                      textField: {
                                        required: true,
                                        size: "small",
                                        helperText:
                                          errorMessages.programada_hora_termino,
                                        error:
                                          !!errorMessages.programada_hora_termino,
                                      },
                                    }}
                                  />
                                </LocalizationProvider>
                              </Grid>

                              <Grid size={12}>
                                <Typography size="body">
                                  Repetición de la ocurrencia
                                </Typography>
                                <Divider></Divider>
                              </Grid>

                              <Grid size={12} ref={daysPRef}>
                                <Grid container spacing={2} columns={14}>
                                  {DAYS.map((dia) => (
                                    <Grid size={2} key={dia}>
                                      <FormControlLabel
                                        control={
                                          <Checkbox
                                            test_id={toSnakeCase(dia)}
                                            checked={formData.days[dia]}
                                            onChange={handleCheckboxChange}
                                            name={dia}
                                          />
                                        }
                                        label={dia}
                                      />
                                    </Grid>
                                  ))}
                                </Grid>

                                {!!errorMessages.days && (
                                  <Grid size={12}>
                                    <Typography color="error" size="small">
                                      {errorMessages.days}
                                    </Typography>
                                  </Grid>
                                )}
                              </Grid>

                              <Grid size={12}>
                                <Typography size="body">
                                  Periodo que debe durar la contingencia
                                  programada
                                </Typography>
                                <Divider></Divider>
                              </Grid>

                              <Grid size={6} ref={datePRef}>
                                <LocalizationProvider
                                  dateAdapter={AdapterDayjs}
                                  adapterLocale={"es"}
                                >
                                  <DatePicker
                                    test_id={toSnakeCase(
                                      "programada_inicio_contingencia"
                                    )}
                                    sx={{ width: "100%" }}
                                    label="Fecha de inicio periodo"
                                    value={
                                      formData.programada_inicio_contingencia
                                    }
                                    onChange={(newValue) =>
                                      setFormData({
                                        ...formData,
                                        programada_inicio_contingencia:
                                          newValue,
                                      })
                                    }
                                    minDate={dayjs()
                                      .subtract(1, "month")
                                      .startOf("month")}
                                    maxDate={
                                       bajaDate && typeContingencia !== "ZONAL"
                                          ? dayjs.min(dayjs(bajaDate).endOf("day"), yearEndLimit)
                                         : yearEndLimit
                                      }
                                    slotProps={{
                                      textField: {
                                        required: true,
                                        size: "small",
                                        helperText:
                                          errorMessages.programada_inicio_contingencia,
                                        error:
                                          !!errorMessages.programada_inicio_contingencia,
                                      },
                                    }}
                                  />
                                </LocalizationProvider>
                              </Grid>
                              <Grid size={6}>
                                <LocalizationProvider
                                  dateAdapter={AdapterDayjs}
                                  adapterLocale={"es"}
                                >
                                  <DatePicker
                                    test_id={toSnakeCase(
                                      "programada_fin_contingencia"
                                    )}
                                    sx={{ width: "100%" }}
                                    label="Fecha de término periodo"
                                    value={formData.programada_fin_contingencia}
                                    onChange={(newValue) =>
                                      setFormData({
                                        ...formData,
                                        programada_fin_contingencia: newValue,
                                      })
                                    }
                                    minDate={
                                      formData.programada_inicio_contingencia
                                    }
                                    maxDate={
                                       bajaDate && typeContingencia !== "ZONAL"
                                          ? dayjs.min(dayjs(bajaDate).endOf("day"), yearEndLimit)
                                         : yearEndLimit
                                      }
                                    slotProps={{
                                      textField: {
                                        required: true,
                                        size: "small",
                                        helperText:
                                          errorMessages.programada_fin_contingencia,
                                        error:
                                          !!errorMessages.programada_fin_contingencia,
                                      },
                                    }}
                                  />
                                </LocalizationProvider>
                              </Grid>
                              {bajaDate !== null && (
                                <Grid size={12}>
                                  <Typography
                                    variant="body2"
                                    component="p"
                                    align="left"
                                    sx={{
                                      display: "block",
                                      color: "warning.main",
                                    }}
                                    role="note"
                                  >
                                    *Atención: el RBD seleccionado está dado de
                                    baja. Solo podrá crear contingencias con
                                    fechas anteriores o iguales al día de baja (
                                    {bajaDate}).
                                  </Typography>
                                </Grid>
                              )}
                            </Grid>
                          </FormControl>
                        )}

                        {(typeContingencia === "ZONAL" ||
                          typeContingencia === "ESPECIFICA") && (
                          <>
                            <Grid container spacing={2} ref={datetimeRef}>
                              <Grid size={6}>
                                <LocalizationProvider
                                  dateAdapter={AdapterDayjs}
                                  adapterLocale={"es"}
                                >
                                  <DateTimePicker
                                    test_id={toSnakeCase(
                                      "especifica_fecha_hora_ocurrencia"
                                    )}
                                    sx={{ width: "100%" }}
                                    label="Fecha y hora de ocurrencia"
                                    value={
                                      formData.especifica_fecha_hora_ocurrencia
                                    }
                                    onChange={(newValue) =>
                                      setFormData({
                                        ...formData,
                                        especifica_fecha_hora_ocurrencia:
                                          newValue,
                                      })
                                    }
                                    minDate={dayjs()
                                      .subtract(1, "month")
                                      .startOf("month")}
                                    maxDate={
                                      bajaDate && typeContingencia !== "ZONAL"
                                        ? dayjs(bajaDate).endOf("day")
                                        : undefined
                                    }
                                    slotProps={{
                                      textField: {
                                        required: true,
                                        size: "small",
                                        helperText:
                                          errorMessages.especifica_fecha_hora_ocurrencia,
                                        error:
                                          !!errorMessages.especifica_fecha_hora_ocurrencia,
                                      },
                                    }}
                                    disableFuture
                                  />
                                </LocalizationProvider>
                              </Grid>
                              <Grid size={6}>
                                <LocalizationProvider
                                  dateAdapter={AdapterDayjs}
                                  adapterLocale={"es"}
                                >
                                  <DateTimePicker
                                    test_id={toSnakeCase(
                                      "especifica_fecha_hora_resolucion"
                                    )}
                                    sx={{ width: "100%" }}
                                    label="Fecha y hora de resolución"
                                    value={
                                      formData.especifica_fecha_hora_resolucion
                                    }
                                    onChange={(newValue) =>
                                      setFormData({
                                        ...formData,
                                        especifica_fecha_hora_resolucion:
                                          newValue,
                                      })
                                    }
                                    minDate={
                                      formData.especifica_fecha_hora_ocurrencia
                                    }
                                    maxDate={
                                      bajaDate && typeContingencia !== "ZONAL"
                                        ? dayjs(bajaDate).endOf("day")
                                        : undefined
                                    }
                                    slotProps={{
                                      textField: {
                                        required: true,
                                        size: "small",
                                        helperText:
                                          errorMessages.especifica_fecha_hora_resolucion,
                                        error:
                                          !!errorMessages.especifica_fecha_hora_resolucion,
                                      },
                                    }}
                                    disableFuture
                                  />
                                </LocalizationProvider>
                              </Grid>

                              {bajaDate !== null &&
                                typeContingencia !== "ZONAL" && (
                                  <Grid size={12}>
                                    <Typography
                                      variant="body2"
                                      component="p"
                                      align="left"
                                      sx={{
                                        display: "block",
                                        color: "warning.main",
                                      }}
                                      role="note"
                                    >
                                      *Atención: el RBD seleccionado está dado
                                      de baja. Solo podrá crear contingencias
                                      con fechas anteriores o iguales al día de
                                      baja ({bajaDate}).
                                    </Typography>
                                  </Grid>
                                )}
                            </Grid>

                            {!loadingPdf ? (
                              <>
                                <FormControl
                                  sx={{ width: "100%", maxWidth: "100%" }}
                                >
                                  <TextField
                                    test_id={toSnakeCase(
                                      "especifica_descripcion_falla"
                                    )}
                                    required={!formData.contingencia_programada}
                                    multiline
                                    minRows={4}
                                    maxRows={30}
                                    id="outlined-required"
                                    label="Descripción de falla"
                                    placeholder="Descripción de falla"
                                    size="small"
                                    value={
                                      formData.especifica_descripcion_falla
                                    }
                                    onChange={(event) =>
                                      setFormData({
                                        ...formData,
                                        especifica_descripcion_falla:
                                          event.target.value,
                                      })
                                    }
                                  />
                                </FormControl>
                              </>
                            ) : (
                              <>
                                <InputFake
                                  value={formData.especifica_descripcion_falla}
                                ></InputFake>
                              </>
                            )}
                          </>
                        )}
                        {typeContingencia !== "PROGRAMADA" && (
                          <Box ref={evidenceRef}>
                            <InputFile
                              onFileSelect={setFile}
                              fileType="pdf"
                              placeholder="Subir evidencia (formato PDF)"
                            />
                            <Typography
                              variant="small"
                              align="left"
                              sx={{
                                marginBottom: "5px",
                                color: evError ? "red" : "#111",
                              }}
                            >
                              {evError ? "Debe adjuntar evidencia" : ""}
                            </Typography>

                            <Typography
                              variant="small"
                              align="left"
                              sx={{
                                mt: "5px",
                                display: "block",
                              }}
                            >
                              *Atención: Se recomienda que las fotografías
                              dentro de la evidencia vengan georeferenciadas
                              (marca de fecha y lugar en la que se tomó) esto
                              será validado por SUBTEL y no por la plataforma
                              SAGEC.
                            </Typography>
                          </Box>
                        )}
                      </Stack>
                    </form>
                  </Box>
                  <Stack
                    sx={{
                      paddingLeft: "9rem",
                      paddingRight: "9rem",
                      paddingBottom: "3rem",
                    }}
                  >
                    <Grid>
                      {submitConfirm ? (
                        <Grid
                          display="flex"
                          justifyContent="center"
                          alignItems="center"
                          size={12}
                          sx={{ paddingBottom: "3rem" }}
                        >
                          <Alert
                            icon={false}
                            variant="filled"
                            severity="warning"
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              "& .MuiAlert-message": {
                                textAlign: "center",
                                width: "inherit",
                              },
                            }}
                          >
                            <Typography
                              variant="body"
                              color="inherit"
                              sx={{ textAlign: "center" }}
                            >
                              Revise que todos los campos tienen la información
                              correcta antes de enviar el levantamiento de
                              Contingencia, al clickear “Crear contingencia” el
                              documento queda firmado por el operador.
                            </Typography>
                          </Alert>
                        </Grid>
                      ) : (
                        ""
                      )}
                    </Grid>
                    <PageButtonBlack
                      form="contingencia"
                      loading={loadingButton}
                    >
                      Crear contingencia
                    </PageButtonBlack>
                  </Stack>
                </>
              )}
            </>
          )}
        </PageBgBlock>
        <ModalStandard
          open={open}
          error={modalError}
          title={modalContent}
          btnText="Ir al listado"
          onClick={() => navigate("/contingencias_lista")}
          onClose={handleClose}
        ></ModalStandard>

        {/* Modal para bloqueo por rangos prohibidos */}
        <ModalStandard
          open={blockModalOpen}
          error={true}
          title="No se puede crear la contingencia"
          msg={blockModalMessage}
          btnText="Cerrar"
          onClick={() => setBlockModalOpen(false)}
          onClose={() => setBlockModalOpen(false)}
        />
      </PageBody>
      {loadingPdf ? (
        <Box
          sx={{
            maxWidth: "100%",
            overflow: "hidden",
            position: "absolute",
            width: "1200px",
            height: "0",
          }}
        >
          <Box ref={contingenciasRef} sx={{ padding: "12px" }}>
            <ContingenciasHiddenPreview
              formData={formData}
              textContingencia={textContingencia}
              typeContingencia={typeContingencia}
              evidence={evidence}
            ></ContingenciasHiddenPreview>
          </Box>
        </Box>
      ) : null}
    </>
  );
}
